export const VIRTUAL_PAGE_SIZE = 500;
export const SOURCE_NAME_TAG = "northbeam:shopify:source_name:";
